export default "__VITE_ASSET__CV5Ytk8Y__"